import { TypeRequest } from "../common/enums/AllEnums";
import { IListBase, IListDetail, ListType } from "../interfaces/IListado";
import { IResponse } from "../interfaces/IResponse";
import { BisApiRequest } from "./apis";

export const GetListBase = (): Promise<IResponse> => {
    return new Promise<IResponse>(async (resolve, reject) => {
        BisApiRequest('/Listado/ObtenerListadosByUsuario', TypeRequest.get).then((response) => {
            resolve(response.data);
        }).catch((error: any) => {
            reject(error?.response?.data);
        });
    })
}

export const GetListBaseDetailByID = (listID: number): Promise<IResponse> => {
    return new Promise<IResponse>((resolve, reject) => {
        BisApiRequest(`/Listado/ObtenerListadoDetallesByListadoID?listadoID=${listID}`, TypeRequest.get).then((response) => {
            resolve(response.data);
        }).catch((error: any) => {
            reject(error?.response?.data);
        });
    })
}

export const GetUpdateFrecuencys = (): Promise<IResponse> => {
    return new Promise<IResponse>((resolve, reject) => {
        BisApiRequest(`/Servicio/ObtenerFrecuenciaActualizaciones`, TypeRequest.get).then((response) => {
            resolve(response.data);
        }).catch((error: any) => {
            reject(error?.response?.data);
        });
    })
}

export const GetListBaseByListID = (listID: number): Promise<IResponse> => {
    return new Promise<IResponse>((resolve, reject) => {
        BisApiRequest(`/Listado/ObtenerListadoByID?listadoID=${listID}`, TypeRequest.get).then((response) => {
            resolve(response.data);
        }).catch((error: any) => {
            reject(error?.response?.data);
        });
    })
}

export const GetListBaseDetailByQuery = (query: string): Promise<IResponse> => {
    return new Promise<IResponse>((resolve, reject) => {
        BisApiRequest(`/Listado/ObtenerListadoDetallesByQuery?query=${query}`, TypeRequest.get).then((response) => {
            resolve(response.data);
        }).catch((error: any) => {
            reject(error?.response?.data);
        });
    })
}

export const DeactiveListBaseById = (listID: number): Promise<IResponse> => {
    return new Promise<IResponse>((resolve, reject) => {
        BisApiRequest(`/Listado/DesactivarListado?listadoID=${listID}`, TypeRequest.put).then((response) => {
            resolve(response.data);
        }).catch((error: any) => {
            reject(error?.response?.data);
        });
    })
}

export const InsertListBase = (listBase: IListBase, listBaseDetalle: IListDetail[]): Promise<IResponse> => {
    return new Promise<IResponse>((resolve, reject) => {

        listBase.listadoDetalle = null;
        BisApiRequest(`/Listado/InsertarListado`, TypeRequest.post, listBase).then((response) => {
            if (listBase.listadoTipo === ListType.Archivo) {
                let result: IListBase = response.data.data;
                InsertListBaseDetail(result.listadoID, listBaseDetalle, 0, 5000).then((responseD) => {
                    resolve(response.data);
                }).catch((error: any) => {
                    reject(error?.responseD?.data);
                })
            }
            else {
                resolve(response.data);
            }
            
        }).catch((error: any) => {
            reject(error?.response?.data);
        });
    })
}

export const UpdateListBase = (listBase: IListBase, listBaseDetalleInsertar: IListDetail[], listBaseDetalleActualizar: IListDetail[], listBaseDetalleDesactivar: IListDetail[]): Promise<IResponse> => {
    return new Promise<IResponse>((resolve, reject) => {

        listBase.listadoDetalle = null;
        BisApiRequest(`/Listado/ActualizarListado`, TypeRequest.put, listBase).then((response) => {
            if (listBase.listadoTipo === ListType.Archivo) {
                let result: IListBase = response.data.data;
                InsertListBaseDetail(result.listadoID, listBaseDetalleInsertar, 0, 5000).then((responseI) => {
                    UpdateListBaseDetail(result.listadoID, listBaseDetalleActualizar, 0, 5000).then((responseU) => {
                        DeactiveListBaseDetail(result.listadoID, listBaseDetalleDesactivar, 0, 5000).then((responseD) => {
                            resolve(response.data);
                        }).catch((error: any) => {
                            reject(error?.responseD?.data);
                        })
                    }).catch((error: any) => {
                        reject(error?.responseU?.data);
                    })
                }).catch((error: any) => {
                    reject(error?.responseI?.data);
                })
            }
            else {
                resolve(response.data);
            }
        }).catch((error: any) => {
            reject(error?.response?.data);
        });
    })
}

export const InsertListBaseDetail = (listID: number, listBaseDetalle: IListDetail[], start: number, chunkSize: number ): Promise<IResponse> => {
    return new Promise<any>((resolve, reject) => {
        if (start < listBaseDetalle.length){
            const end = Math.min(start + chunkSize, listBaseDetalle.length);
            const list = listBaseDetalle.slice(start, end);
            BisApiRequest(`/Listado/InsertarListadoDetalle?listadoID=${listID}`, TypeRequest.post, list).then((response) => {
                if (end < listBaseDetalle.length) {
                    return InsertListBaseDetail(listID, listBaseDetalle, end, chunkSize)
                        .then(resolve)
                        .catch(reject);
                } else {
                    resolve(response);
                }
            }).catch((error: any) => {
                reject(error?.response?.data);
            });
        }
        else {
            resolve("");
        }
    })
}

export const UpdateListBaseDetail = (listID: number, listBaseDetalle: IListDetail[], start: number, chunkSize: number ): Promise<IResponse> => {
    return new Promise<any>((resolve, reject) => {
        if (start < listBaseDetalle.length){
            const end = Math.min(start + chunkSize, listBaseDetalle.length);
            const list = listBaseDetalle.slice(start, end);
            BisApiRequest(`/Listado/ActualizarListadoDetalle?listadoID=${listID}`, TypeRequest.put, list).then((response) => {
                if (end < listBaseDetalle.length) {
                    return UpdateListBaseDetail(listID, listBaseDetalle, end, chunkSize)
                        .then(resolve)
                        .catch(reject);
                } else {
                    resolve(response);
                }
            }).catch((error: any) => {
                reject(error?.response?.data);
            });
        }
        else {
            resolve("");
        }
    })
}

export const DeactiveListBaseDetail = (listID: number, listBaseDetalle: IListDetail[], start: number, chunkSize: number ): Promise<IResponse> => {
    return new Promise<any>((resolve, reject) => {
        if (start < listBaseDetalle.length){
            const end = Math.min(start + chunkSize, listBaseDetalle.length);
            const list = listBaseDetalle.slice(start, end);
            BisApiRequest(`/Listado/DesactivarListadoDetalle?listadoID=${listID}`, TypeRequest.put, list).then((response) => {
                if (end < listBaseDetalle.length) {
                    return DeactiveListBaseDetail(listID, listBaseDetalle, end, chunkSize)
                        .then(resolve)
                        .catch(reject);
                } else {
                    resolve(response);
                }
            }).catch((error: any) => {
                reject(error?.response?.data);
            });
        }
        else {
            resolve("");
        }
    })
}